import avatar from "@/assets/shared/avatar-2.svg";
import avatar2 from "@/assets/shared/avatars/avatar-3.svg";
import avatar3 from "@/assets/shared/avatars/avatar-4.svg";
import avatar4 from "@/assets/shared/avatars/avatar-5.svg";
import avatar5 from "@/assets/shared/avatars/avatar-6.svg";
import avatar6 from "@/assets/shared/avatars/avatar-7.svg";
import avatar7 from "@/assets/shared/avatars/avatar-8.svg";
import avatar8 from "@/assets/shared/avatars/avatar-9.svg";
import avatar9 from "@/assets/shared/avatars/avatar-10.svg";

const getRoundedTimeFromNow = (
  offsetMs: number,
  roundingUnitMs: number = 30 * 60 * 1000
): string => {
  const now = new Date().getTime();
  const targetTime = now + offsetMs;
  const roundedTime = Math.round(targetTime / roundingUnitMs) * roundingUnitMs;
  const date = new Date(roundedTime);

  // Format as YYYY-MM-DD HH:MM:SS
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const directoryProfiles = [
  {
    id: "1",
    uuid: "1",
    firstName: "Courtney",
    lastName: "Henry",
    email: "courtney@example.com",
    country: "United States",
    title: "Software Engineer",
    companyName: "Google",
    imageUrl: avatar,
    linkedinUrl: "",
    anyPastMeetings: true,
    meetingsCount: 10,
    spokenLanguages: ["ENGLISH", "SPANISH"],
    soonestAvailabilities: [
      {
        startTime: getRoundedTimeFromNow(60 * 60 * 1000),
        endTime: getRoundedTimeFromNow(60 * 60 * 1000 + 30 * 60 * 1000),
      },
      {
        startTime: getRoundedTimeFromNow(60 * 60 * 1000 + 30 * 60 * 1000),
        endTime: getRoundedTimeFromNow(60 * 60 * 1000 + 60 * 60 * 1000),
      },
    ],
    userProgramProfile: [
      {
        expertise: 3,
        experience: 4,
      },
    ],
  },
  {
    id: "2",
    uuid: "2",
    firstName: "Alex",
    lastName: "Johnson",
    email: "alex@example.com",
    country: "United Kingdom",
    title: "Product Manager",
    companyName: "Apple",
    imageUrl: avatar2,
    linkedinUrl: "",
    meetingsCount: 5,
    anyPastMeetings: true,
    spokenLanguages: ["ENGLISH", "POLISH"],
    soonestAvailabilities: [
      {
        startTime: "2099-03-24 21:00:00 +0500",
        endTime: "2099-03-24 21:30:00 +0500",
      },
      {
        startTime: "2099-03-24 21:30:00 +0500",
        endTime: "2099-03-24 22:00:00 +0500",
      },
    ],
    userProgramProfile: [
      {
        expertise: 2,
        experience: 1,
      },
    ],
  },
  {
    id: "3",
    uuid: "3",
    firstName: "Wendy",
    lastName: "Lee",
    email: "wendy@example.com",
    country: "Canada",
    title: "Product Manager",
    companyName: "Amazon",
    imageUrl: avatar3,
    linkedinUrl: "",
    anyPastMeetings: true,
    meetingsCount: 3,
    spokenLanguages: ["FRENCH", "ENGLISH"],
    soonestAvailabilities: [
      {
        startTime: getRoundedTimeFromNow(60 * 60 * 1000),
        endTime: getRoundedTimeFromNow(60 * 60 * 1000 + 30 * 60 * 1000),
      },
      {
        startTime: getRoundedTimeFromNow(60 * 60 * 1000 + 30 * 60 * 1000),
        endTime: getRoundedTimeFromNow(60 * 60 * 1000 + 60 * 60 * 1000),
      },
    ],
    userProgramProfile: [
      {
        expertise: 1,
        experience: 5,
      },
    ],
  },
  {
    id: "4",
    uuid: "4",
    firstName: "Michael",
    lastName: "Chang",
    email: "michael@example.com",
    country: "Singapore",
    title: "Marketing Manager",
    companyName: "Facebook",
    imageUrl: avatar4,
    linkedinUrl: "",
    meetingsCount: 2,
    anyPastMeetings: true,
    spokenLanguages: ["TAMIL"],
    soonestAvailabilities: [
      {
        startTime: "2099-05-25 21:00:00 +0500",
        endTime: "2099-05-25 21:30:00 +0500",
      },
      {
        startTime: "2099-05-25 21:30:00 +0500",
        endTime: "2099-05-25 22:00:00 +0500",
      },
    ],
    userProgramProfile: [
      {
        expertise: 2,
        experience: 3,
      },
    ],
  },
  {
    id: "5",
    uuid: "5",
    firstName: "Emma",
    lastName: "Rodriguez",
    email: "emma@example.com",
    country: "Spain",
    title: "UX Researcher",
    companyName: "Twitter",
    imageUrl: avatar5,
    linkedinUrl: "",
    meetingsCount: 1,
    anyPastMeetings: false,
    spokenLanguages: ["SPANISH"],
    soonestAvailabilities: [
      {
        startTime: "2099-05-24 17:00:00 +0500",
        endTime: "2099-05-24 17:30:00 +0500",
      },
      {
        startTime: "2099-05-24 17:30:00 +0500",
        endTime: "2099-05-24 18:00:00 +0500",
      },
    ],
    userProgramProfile: [
      {
        expertise: 3,
        experience: 3,
      },
    ],
  },
  {
    id: "6",
    uuid: "6",
    firstName: "Sarah",
    lastName: "Henry",
    email: "sarah@example.com",
    country: "United States",
    title: "Business Analyst",
    companyName: "Google",
    imageUrl: avatar6,
    linkedinUrl: "",
    meetingsCount: 8,
    anyPastMeetings: false,
    spokenLanguages: ["SPANISH", "ENGLISH"],
    soonestAvailabilities: [
      {
        startTime: "2099-06-14 17:00:00 +0500",
        endTime: "2099-06-14 17:30:00 +0500",
      },
      {
        startTime: "2099-06-14 17:30:00 +0500",
        endTime: "2099-06-14 18:00:00 +0500",
      },
    ],
    userProgramProfile: [
      {
        expertise: 4,
        experience: 1,
      },
    ],
  },
  {
    id: "7",
    uuid: "7",
    firstName: "Dave",
    lastName: "Smith",
    email: "dave@example.com",
    country: "United Kingdom",
    title: "Creative Director",
    companyName: "Nike",
    imageUrl: avatar7,
    linkedinUrl: "",
    meetingsCount: 7,
    anyPastMeetings: false,
    spokenLanguages: ["ENGLISH"],
    soonestAvailabilities: [
      {
        startTime: "2099-06-18 17:00:00 +0500",
        endTime: "2099-06-18 17:30:00 +0500",
      },
      {
        startTime: "2099-06-18 17:30:00 +0500",
        endTime: "2099-06-18 18:00:00 +0500",
      },
    ],
    userProgramProfile: [
      {
        expertise: 5,
        experience: 3,
      },
    ],
  },
  {
    id: "8",
    uuid: "8",
    firstName: "Sarah",
    lastName: "Lee",
    email: "sarah@example.com",
    country: "Canada",
    title: "Financial Analyst",
    companyName: "Hubspot",
    imageUrl: avatar8,
    linkedinUrl: "",
    meetingsCount: 6,
    anyPastMeetings: false,
    spokenLanguages: ["FRENCH"],
    soonestAvailabilities: [
      {
        startTime: "2099-07-08 17:00:00 +0500",
        endTime: "2099-07-08 17:30:00 +0500",
      },
      {
        startTime: "2099-07-08 17:30:00 +0500",
        endTime: "2099-07-08 18:00:00 +0500",
      },
    ],
    userProgramProfile: [
      {
        expertise: 5,
        experience: 5,
      },
    ],
  },
  {
    id: "9",
    uuid: "9",
    firstName: "Tom",
    lastName: "Chang",
    email: "tom@example.com",
    country: "Singapore",
    title: "Logistics Coordinator",
    companyName: "Fedex",
    imageUrl: avatar9,
    linkedinUrl: "",
    meetingsCount: 4,
    anyPastMeetings: true,
    spokenLanguages: ["ENGLISH"],
    soonestAvailabilities: [
      {
        startTime: "2099-07-11 14:00:00 +0500",
        endTime: "2099-07-11 14:30:00 +0500",
      },
      {
        startTime: "2099-07-11 14:30:00 +0500",
        endTime: "2099-07-11 15:00:00 +0500",
      },
    ],
    userProgramProfile: [
      {
        expertise: 1,
        experience: 1,
      },
    ],
  },
];
